import { render, staticRenderFns } from "./TambahPoint.vue?vue&type=template&id=854f3e2a&"
import script from "./TambahPoint.vue?vue&type=script&lang=js&"
export * from "./TambahPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports